import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const ListIcon = ({ width = 24, height = 24, fill = '#52575C' }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M9 1c-1.105 0-2 .895-2 2H6c-.796 0-1.559.316-2.121.879C3.316 4.44 3 5.204 3 6v14c0 .796.316 1.559.879 2.121C4.44 22.684 5.204 23 6 23h12c.796 0 1.559-.316 2.121-.879.563-.562.879-1.325.879-2.121V6c0-.796-.316-1.559-.879-2.121C19.56 3.316 18.796 3 18 3h-1c0-1.105-.895-2-2-2H9zm8 4c0 1.105-.895 2-2 2H9c-1.105 0-2-.895-2-2H6c-.265 0-.52.105-.707.293C5.105 5.48 5 5.735 5 6v14c0 .265.105.52.293.707.187.188.442.293.707.293h12c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V6c0-.265-.105-.52-.293-.707C18.52 5.105 18.265 5 18 5h-1zM9 4v1h6V3H9v1z"
      clipRule="evenodd"
    />
    <path
      fill={fill}
      fillRule="evenodd"
      d="M7 12c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1zM7 17c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
